"use strict";
module.exports = {
    entityModel: 'complaint',
    events: {
        COMPLAINT_UPDATED: 'COMPLAINT_UPDATED',
        COMPLAINT_CREATED: 'COMPLAINT_CREATED',
        COMPLAINT_CANCELLED: 'COMPLAINT_CANCELLED',
        COMPLAINT_PLACED: 'COMPLAINT_PLACED',
        COMPLAINT_REVIEW_STARTED: 'COMPLAINT_REVIEW_STARTED',
        COMPLAINT_RESOLVED: 'COMPLAINT_RESOLVED',
    },
    actions: {
        get: 'v1.complaint.get',
        list: 'v1.complaint.list',
        writeComplaint: 'v1.complaint.writeComplaint',
        beginReview: 'v1.complaint.beginReview',
        comment: 'v1.complaint.comment',
        resolveComplaint: 'v1.complaint.resolveComplaint',
        cancel: 'v1.complaint.cancel',
        ensureInvariants: 'v1.complaint.ensureInvariants',
        upsert: 'v1.complaint.upsert',
        upsertWhenEmpty: 'v1.complaint.upsertWhenEmpty',
        updateWhenEmpty: 'v1.complaint.updateWhenEmpty',
        update: 'v1.complaint.update',
    },
    complaintTypes: {
        customerGotWrongOrder: 'customerGotWrongOrder',
        wrongArticles: 'wrongArticles',
        wrongPrices: 'wrongPrices',
        missingArticles: 'missingArticles',
        articlesBrokenInTransport: 'articlesBrokenInTransport',
        articleDoesNotMeetQualityExpectations: 'articleDoesNotMeetQualityExpectations',
        lostInDelivery: 'lostInDelivery',
        cancelledDueToLateHandling: 'cancelledDueToLateHandling',
        other: 'other',
    },
    resolutionTypes: {
        credit: 'credit',
        return: 'return',
        customerPayed: 'customerPayed',
        other: 'other',
        none: 'none',
    },
    assignedResponsibilities: {
        warehouse: 'warehouse',
        supplier: 'supplier',
        flaivy: 'flaivy',
        none: 'none',
    },
    complaintStates: {
        received: 'received',
        inReview: 'inReview',
        resolved: 'resolved',
    },
    complaintRows: {},
    complaintImages: {},
};
